"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Objects = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M9.92874646,4.24275212 L12.5076053,8.5405581 C13.2666961,8.19344859 14.1107569,8 15,8 C18.3137085,8 21,10.6862915 21,14 C21,17.3137085 18.3137085,20 15,20 C12.0273203,20 9.55956212,17.8381738 9.08311059,15.0009065 L3.5,15 C3.18608093,15 2.8367157,14.662735 3.07125354,14.2427521 L9.07125354,4.24275212 C9.28173828,3.89295959 9.76989746,3.94740295 9.92874646,4.24275212 Z M15,9 C14.2991904,9 13.6320559,9.14418029 13.0266411,9.40449624 L15.9287465,14.2427521 C16.1239476,14.5296062 15.9287465,15 15.5,15 L10.1001898,15.0008452 C10.5637866,17.2826644 12.5813407,19 15,19 C17.7614237,19 20,16.7614237 20,14 C20,11.2385763 17.7614237,9 15,9 Z M9.5,5.47182532 L4.38309519,14 L14.6169048,14 L9.5,5.47182532 Z" })));
};
Objects.displayName = 'Objects';
exports.default = Objects;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Objects.js.map